<section id="sensor-warranty-check-grid">
  <p-table stripedRows #dt [columns]="selectedCols" [value]="rows" [paginator]="true" [rows]="rowsPerPage"
     selectionMode="none" exportFilename="aqmesh-sensor-warranty-check"
    styleClass="p-datatable-lg  p-datatable-gridlines" [resizableColumns]="true" stateStorage="local"
    stateKey="sensor_warranty">
    <ng-template pTemplate="caption">
      <div class="p-grid">
        <div class="th-button p-col p-grid p-jc-end">
          <p-select ngDefaultControl [options]="rowsPerPageOptions" [(ngModel)]="rowsPerPage" positionStyle="fixed"
            pTooltip="Number of records display per page" tooltipEvent="hover" showDelay="500" hideDelay="500"
            styleClass="row-options" (onChange)="setPreferences()"></p-select>
          <label class="pageCountSeperator">|</label>

          <label *ngIf="dt.totalRecords !== (rows?.length ? rows?.length : 0)" class="row-count" positionStyle="fixed"
            pTooltip="{{tt === undefined ? col.header : tt.rows_Total}}">{{dt.totalRecords}}</label>
          <label *ngIf="dt.totalRecords !== (rows?.length ? rows?.length : 0)" positionStyle="fixed"
            pTooltip="{{tt === undefined ? col.header : tt.row_Select}}" class="pageCountSeperator">of</label>
          <label tooltipEvent="hover" showDelay="500" hideDelay="500" class="row-count" positionStyle="fixed"
            pTooltip="{{tt === undefined ? col.header : tt.row_Select}}">{{(rows?.length ? rows?.length : 0)}}</label>

          <button type="button" positionStyle="fixed" pTooltip="{{(tt === undefined) ? col.header : tt.row_Filter}}"
            tooltipEvent="hover" showDelay="500" hideDelay="500" pButton icon="fas fa-undo" label="Filters"
            class="p-button-raised p-button-secondary" (click)="reset()"></button>
          <p-multiSelect ngDefaultControl [options]="cols" [(ngModel)]="selectedCols" [ngModelOptions]="{standalone: true}"
            optionLabel="header" selectedItemsLabel="{0} columns" placeholder="Choose Columns"
            (onChange)="setPreferences()" [maxSelectedLabels]="0"></p-multiSelect>
          <button type="button" pButton icon="fas fa-magic" positionStyle="fixed" pTooltip="{{tt.resetColumn}}"
            tooltipEvent="hover" showDelay="500" hideDelay="500" class="p-button-raised p-button-secondary"
            (click)="clearCols()" [disabled]="isSearching" showDelay="500" hideDelay="500"></button>
          <button type="button" pButton icon="fas fa-th" class="p-button-success" (click)="dt.exportCSV()"
            [disabled]="(rows?.length ? rows?.length : 0) === 0" positionStyle="fixed"
            pTooltip="Export visible rows to CSV, for best results please set your spreadsheet to auto-import comma separated data files"
            tooltipEvent="hover" showDelay="500" hideDelay="500"></button>
          <button type="button" pButton icon="fas fa-file" class="p-button-success" (click)="export()"
            [disabled]="(rows?.length ? rows?.length : 0) === 0" positionStyle="fixed"
            pTooltip="Export all rows to CSV, for best results please set your spreadsheet to auto-import comma separated data files"
            tooltipEvent="hover" showDelay="500" hideDelay="500"></button>
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="colgroup" let-columns>
      <colgroup>
        <col *ngFor="let col of columns">
      </colgroup>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th *ngFor="let col of columns" pResizableColumn [pSortableColumn]="col.field"
          [ngStyle]="{'width': col.colWidth}">
          <p-sortIcon [field]="col.field"></p-sortIcon>
          {{col.header}}
        </th>
      </tr>
      <tr>
        <th *ngFor="let col of columns" pResizableColumn [ngSwitch]="col.datatype" [ngStyle]="{'width': col.colWidth}">
          <ng-container *ngSwitchCase="'string'" [ngSwitch]="col.field">
            <p-multiSelect ngDefaultControl [options]="col.filter" [maxSelectedLabels]="0"
              (onChange)="dt.filter($event.value, col.field, 'in')" appendTo="body" *ngSwitchCase="'part_number'"
              positionStyle="fixed" pTooltip="{{tt === undefined ? col.header : tt.part_number}}"
              [(ngModel)]="searchFailures[col.field]" selectedItemsLabel="{0} {{col.header}}s" hideDelay="1000">
            </p-multiSelect>
            <p-multiSelect ngDefaultControl [options]="col.filter" [maxSelectedLabels]="0"
              (onChange)="dt.filter($event.value, col.field, 'in')" appendTo="body" *ngSwitchCase="'owner_name'"
              positionStyle="fixed" pTooltip="{{tt === undefined ? col.header : tt.owner_name}}"
              [(ngModel)]="searchFailures[col.field]" selectedItemsLabel="{0} {{col.header}}s">
            </p-multiSelect>
            <p-multiSelect ngDefaultControl [options]="col.filter" [maxSelectedLabels]="0"
              (onChange)="dt.filter($event.value, col.field, 'in')" appendTo="body" *ngSwitchCase="'distributor'"
              positionStyle="fixed" pTooltip="{{tt === undefined ? col.header : tt.distributor}}"
              [(ngModel)]="searchFailures[col.field]" selectedItemsLabel="{0} {{col.header}}s">
            </p-multiSelect>
            <p-multiSelect ngDefaultControl [options]="col.filter" [maxSelectedLabels]="0"
              (onChange)="dt.filter($event.value, col.field, 'in')" appendTo="body" *ngSwitchCase="'sales_type'"
              positionStyle="fixed" pTooltip="{{tt === undefined ? col.header : tt.sales_type}}" [escape]="false"
              [(ngModel)]="searchFailures[col.field]" selectedItemsLabel="{0} {{col.header}}s">
            </p-multiSelect>
            <p-multiSelect ngDefaultControl [options]="col.filter" [maxSelectedLabels]="0"
              (onChange)="dt.filter($event.value, col.field, 'in')" appendTo="body" *ngSwitchCase="'sensor_type'"
              positionStyle="fixed" pTooltip="{{tt === undefined ? col.header : tt.sensor_type}}" [escape]="false"
              [(ngModel)]="searchFailures[col.field]" selectedItemsLabel="{0} {{col.header}}s">
            </p-multiSelect>
            <p-multiSelect ngDefaultControl [options]="col.filter" [maxSelectedLabels]="0"
              (onChange)="dt.filter($event.value, col.field, 'in')" appendTo="body" *ngSwitchCase="'sensor_position'"
              positionStyle="fixed" pTooltip="{{tt === undefined ? col.header : tt.sensor_position}}" [escape]="false"
              [(ngModel)]="searchFailures[col.field]" selectedItemsLabel="{0} {{col.header}}s">
            </p-multiSelect>
            <p-multiSelect ngDefaultControl [options]="col.filter" [maxSelectedLabels]="0"
              (onChange)="dt.filter($event.value, col.field, 'in')" appendTo="body" *ngSwitchCase="'sensor_status'"
              positionStyle="fixed" pTooltip="{{tt === undefined ? col.header : tt.sensor_status}}" [escape]="false"
              [(ngModel)]="searchFailures[col.field]" selectedItemsLabel="{0} {{col.header}}s">
            </p-multiSelect>
            <input ngDefaultControl pInputText type="text" *ngSwitchCase="'project_name'" maxlength="50"
              (input)="dt.filter($event.target.value, col.field, 'contains')" tooltipEvent="hover" showDelay="500"
              hideDelay="500" positionStyle="fixed" pTooltip="{{tt === undefined ? col.header : tt.project_name}}"
              [(ngModel)]="searchFailures[col.field]">
            <input ngDefaultControl pInputText type="text" *ngSwitchCase="'location_name'" maxlength="50"
              (input)="dt.filter($event.target.value, col.field, 'contains')" tooltipEvent="hover" showDelay="500"
              hideDelay="500" positionStyle="fixed" pTooltip="{{tt === undefined ? col.header : tt.pod_location}}"
              [(ngModel)]="searchFailures[col.field]">
            <input ngDefaultControl pInputText type="text" *ngSwitchCase="'amended_by'" maxlength="50"
              (input)="dt.filter($event.target.value, col.field, 'contains')" tooltipEvent="hover" showDelay="500"
              hideDelay="500" positionStyle="fixed" pTooltip="{{tt === undefined ? col.header : tt.last_changed}}"
              [(ngModel)]="searchFailures[col.field]">
          </ng-container>
          <ng-container *ngSwitchCase="'Date'" [ngSwitch]="col.field">
            <p-datepicker ngDefaultControl [(ngModel)]="installation_date" appendTo="body"
              *ngSwitchCase="'installation_date'" selectionMode="range" [readonlyInput]="false" dateFormat="dd-M-yy"
              [showButtonBar]="true" [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2030"
              (onSelect)="dt.filter($event, col.field, 'installationDateRangeFilter')"
              (onClearClick)="clearFilter(col.field)" positionStyle="fixed"
              pTooltip="{{tt === undefined ? col.header : tt.date_fitted}}">
            </p-datepicker>
            <p-datepicker ngDefaultControl [(ngModel)]="expiry_date" appendTo="body" *ngSwitchCase="'expiry_date'"
              selectionMode="range" [readonlyInput]="false" dateFormat="dd-M-yy" [showButtonBar]="true"
              [monthNavigator]="true" [yearNavigator]="true" yearRange="2010:2030"
              (onSelect)="dt.filter($event, col.field, 'expiryDateRangeFilter')" (onClearClick)="clearFilter(col.field)"
              positionStyle="fixed" pTooltip="{{tt === undefined ? col.header : tt.warranty}}">
            </p-datepicker>
            <p-datepicker ngDefaultControl [(ngModel)]="last_communicated" appendTo="body"
              *ngSwitchCase="'last_communicated'" selectionMode="range" [readonlyInput]="false" dateFormat="dd-M-yy"
              [showButtonBar]="true" [monthNavigator]="true" [yearNavigator]="true" yearRange="2010:2030"
              (onSelect)="dt.filter($event, col.field, 'lastCommunicatedRangeFilter')"
              (onClearClick)="clearFilter(col.field)" positionStyle="fixed"
              pTooltip="{{tt === undefined ? col.header : tt.last_communicated}}">
            </p-datepicker>
            <p-datepicker ngDefaultControl [(ngModel)]="failure_date" appendTo="body" *ngSwitchCase="'failure_date'"
              selectionMode="range" [readonlyInput]="false" dateFormat="dd-M-yy" [showButtonBar]="true"
              [monthNavigator]="true" [yearNavigator]="true" yearRange="2010:2030"
              (onSelect)="dt.filter($event, col.field, 'failureDateRangeFilter')"
              (onClearClick)="clearFilter(col.field)" positionStyle="fixed"
              pTooltip="{{tt === undefined ? col.header : tt.failure_date}}">
            </p-datepicker>
            <p-datepicker ngDefaultControl [(ngModel)]="stabilisation_start" appendTo="body"
              *ngSwitchCase="'stabilisation_start'" selectionMode="range" [readonlyInput]="false" dateFormat="dd-M-yy"
              [showButtonBar]="true" [monthNavigator]="true" [yearNavigator]="true" yearRange="2010:2030"
              (onSelect)="dt.filter($event, col.field, 'stabilisationStartRangeFilter')"
              (onClearClick)="clearFilter(col.field)" positionStyle="fixed"
              pTooltip="{{tt === undefined ? col.header : tt.last_stabilised}}">
            </p-datepicker>
            <p-datepicker ngDefaultControl [(ngModel)]="stabilisation_end" appendTo="body"
              *ngSwitchCase="'stabilisation_end'" selectionMode="range" [readonlyInput]="false" dateFormat="dd-M-yy"
              [showButtonBar]="true" [monthNavigator]="true" [yearNavigator]="true" yearRange="2010:2030"
              (onSelect)="dt.filter($event, col.field, 'stabilisationEndRangeFilter')"
              (onClearClick)="clearFilter(col.field)" positionStyle="fixed"
              pTooltip="{{tt === undefined ? col.header : tt.stabilise_end}}">
            </p-datepicker>
            <p-datepicker ngDefaultControl [(ngModel)]="rebasing_start" appendTo="body" *ngSwitchCase="'rebasing_start'"
              selectionMode="range" [readonlyInput]="false" dateFormat="dd-M-yy" [showButtonBar]="true"
              [monthNavigator]="true" [yearNavigator]="true" yearRange="2010:2030"
              (onSelect)="dt.filter($event, col.field, 'rebasingStartRangeFilter')"
              (onClearClick)="clearFilter(col.field)" positionStyle="fixed"
              pTooltip="{{tt === undefined ? col.header : tt.last_rebase}}">
            </p-datepicker>
            <p-datepicker ngDefaultControl [(ngModel)]="amended_date" appendTo="body" *ngSwitchCase="'amended_date'"
              selectionMode="range" [readonlyInput]="false" dateFormat="dd-M-yy" [showButtonBar]="true"
              [monthNavigator]="true" [yearNavigator]="true" yearRange="2010:2030"
              (onSelect)="dt.filter($event, col.field, 'amendedDateRangeFilter')"
              (onClearClick)="clearFilter(col.field)" positionStyle="fixed"
              pTooltip="{{tt === undefined ? col.header : tt.last_ammended}}">
            </p-datepicker>
            <p-datepicker ngDefaultControl [(ngModel)]="created_date" appendTo="body" *ngSwitchCase="'created_date'"
              selectionMode="range" [readonlyInput]="false" dateFormat="dd-M-yy" [showButtonBar]="true"
              [monthNavigator]="true" [yearNavigator]="true" yearRange="2010:2030"
              (onSelect)="dt.filter($event, col.field, 'createdDateRangeFilter')"
              (onClearClick)="clearFilter(col.field)" positionStyle="fixed"
              pTooltip="{{tt === undefined ? col.header : tt.date_recorded}}">
            </p-datepicker>
          </ng-container>
          <p-checkbox ngDefaultControl *ngSwitchCase="'boolean'" binary="true"
            (input)="dt.filter($event.target.value, col.field, 'equals')"></p-checkbox>
          <ng-container *ngSwitchCase="'number'" [ngSwitch]="col.field">
            <input ngDefaultControl *ngSwitchCase="'pod_serial_number'" pInputText type="number" maxlength="50"
              (input)="dt.filter($event.target.value, col.field, 'contains')" tooltipEvent="hover" showDelay="500"
              hideDelay="500" positionStyle="fixed" pTooltip="{{tt === undefined ? col.header : tt.pod_serial}}">
            <input ngDefaultControl *ngSwitchCase="'age_in_months'" pInputText type="number" maxlength="50"
              (input)="dt.filter($event.target.value, col.field, 'gte')" tooltipEvent="hover" showDelay="500"
              hideDelay="500" positionStyle="fixed" pTooltip="{{tt === undefined ? col.header : tt.age_in_months}}">
          </ng-container>
          <ng-container *ngSwitchCase="'text'" [ngSwitch]="col.field">
            <input ngDefaultControl pInputText type="text" *ngSwitchCase="'sensor_serial_number'" maxlength="50"
              (input)="dt.filter($event.target.value, col.field, 'contains')" tooltipEvent="hover" showDelay="500"
              hideDelay="500" positionStyle="fixed" pTooltip="{{tt === undefined ? col.header : tt.sensor_serial}}">
            <input ngDefaultControl *ngSwitchDefault pInputText type="text" maxlength="50"
              (input)="dt.filter($event.target.value, col.field, 'contains')" tooltipEvent="hover" showDelay="500"
              hideDelay="500" positionStyle="fixed" pTooltip="Please Enter.">
          </ng-container>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
      <tr>
        <ng-container *ngFor="let col of columns" [ngSwitch]="col.isReadonly">
          <ng-container *ngSwitchCase="false">
            <td [class]="col.datatype" [ngClass]="{'bg-is-dirty': rowData['isDirty']}" pEditableColumn>
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <input ngDefaultControl type="text" [(ngModel)]="rowData[col.field]"
                    [ngModelOptions]="{standalone: true}" [maxlength]="col.maxLength === 0 ? 50 : col.maxLength"
                    [required]="col.isRequired" pInputText (change)="setDirty(rowData, col.field)">
                  <p-checkbox ngDefaultControl *ngSwitchCase="'boolean'" [(ngModel)]="rowData[col.field]"
                    [ngModelOptions]="{standalone: true}" binary="true" [attr.disabled]="disabled"
                    (onChange)="setCheckboxDirty(rowData, col.header)" tooltipEvent="hover" showDelay="500"
                    hideDelay="500" positionStyle="fixed" pTooltip="Please Check the box."></p-checkbox>
                </ng-template>
                <ng-template pTemplate="output">
                  <ng-container [ngSwitch]="col.datatype">
                    <span class="fr" *ngSwitchCase="'decimal'">{{rowData[col.field]| number:'1.4-4'}}</span>
                    <span *ngSwitchCase="'Date'">{{rowData[col.field] | date:'dd-MMM-yyyy'}}</span>
                    <span *ngSwitchCase="'DateTime'">{{rowData[col.field] | date:'dd-MM-yy HH:mm'}}</span>
                    <span *ngSwitchDefault>{{rowData[col.field]}}</span>
                  </ng-container>
                </ng-template>
              </p-cellEditor>
            </td>
          </ng-container>
          <ng-container *ngSwitchDefault>
            <td [class]="col.datatype" [ngSwitch]="col.datatype"
              [ngClass]="{ 'bg-grey-dark fg-white': col.isReadonly === true}">
              <span class="fr" *ngSwitchCase="'decimal'">{{rowData[col.field]| number:'1.4-4'}}</span>
              <span *ngSwitchCase="'Date'">{{rowData[col.field] | date:'dd-MMM-yyyy'}}</span>
              <p-checkbox ngDefaultControl *ngSwitchCase="'boolean'" [(ngModel)]="rowData[col.field]"
                [ngModelOptions]="{standalone: true}" binary="true" [attr.disabled]="disabled"></p-checkbox>
              <span *ngSwitchDefault>{{rowData[col.field]}}</span>
            </td>
          </ng-container>
        </ng-container>
      </tr>
    </ng-template>
  </p-table>
</section>
